<template>
  <div class="home-container">
    <!-- 导航栏 -->
    <HeaderComponent />

    <!-- 主视觉区域 -->
    <section id="hero" class="hero">
      <div class="container">
        <div class="hero-content">
          <h1 class="hero-title">专业的短视频解决方案</h1>
          <p class="hero-subtitle">为您提供一站式短视频制作、分发和管理服务，助力品牌快速成长</p>
          <div class="hero-buttons">
            <button class="btn btn-primary">了解更多</button>
            <button class="btn btn-secondary">立即咨询</button>
          </div>
        </div>
        <div class="hero-video">
          <div class="video-player">
            <div class="video-thumbnail">
              <i class="fas fa-play-circle"></i>
            </div>
            <div class="video-controls">
              <div class="video-progress"></div>
              <div class="video-info">
                <span class="video-time">0:00 / 2:30</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务展示区 -->
    <section id="services" class="services">
      <div class="container">
        <h2 class="section-title">我们的服务</h2>
        <p class="section-subtitle">专业、高效、创新的短视频解决方案</p>
        <div class="services-grid">
          <div class="service-card">
            <div class="service-icon">
              <i class="fas fa-film"></i>
            </div>
            <h3 class="service-title">视频制作</h3>
            <p class="service-description">专业团队为您打造高质量短视频内容，从策划到后期制作一站式服务</p>
          </div>
          <div class="service-card">
            <div class="service-icon">
              <i class="fas fa-share-alt"></i>
            </div>
            <h3 class="service-title">内容分发</h3>
            <p class="service-description">多平台内容分发策略，提升品牌曝光度和影响力</p>
          </div>
          <div class="service-card">
            <div class="service-icon">
              <i class="fas fa-chart-line"></i>
            </div>
            <h3 class="service-title">数据分析</h3>
            <p class="service-description">实时数据分析，优化内容策略，提升用户转化率</p>
          </div>
          <div class="service-card">
            <div class="service-icon">
              <i class="fas fa-cog"></i>
            </div>
            <h3 class="service-title">技术支持</h3>
            <p class="service-description">专业的技术团队提供7x24小时支持，确保系统稳定运行</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 关于我们 -->
    <section id="about" class="about">
      <div class="container">
        <div class="about-content">
          <h2 class="section-title">关于弋沐</h2>
          <p class="about-text">弋沐是一家专注于短视频领域的科技公司，致力于为企业提供专业的短视频解决方案。我们拥有一支经验丰富的团队，包括策划、拍摄、后期制作和技术支持人员，能够为客户提供全方位的服务。</p>
          <p class="about-text">我们的使命是通过创新的技术和优质的服务，帮助客户在短视频时代取得成功。无论是品牌推广、产品介绍还是内容营销，我们都能为您提供量身定制的解决方案。</p>
        </div>
        <div class="about-stats">
          <div class="stat-item">
            <div class="stat-number">1000+</div>
            <div class="stat-label">合作客户</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">5000+</div>
            <div class="stat-label">制作视频</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">100M+</div>
            <div class="stat-label">视频播放量</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">98%</div>
            <div class="stat-label">客户满意度</div>
          </div>
        </div>
      </div>
    </section>

    <!-- 页脚 -->
    <FooterComponent />
  </div>
</template>

<script>
import HeaderComponent from '../components/Header.vue'
import FooterComponent from '../components/Footer.vue'

export default {
  name: 'HomeView',
  components: {
    HeaderComponent,
    FooterComponent
  },
  data() {
    return {
      form: {
        name: '',
        email: '',
        phone: '',
        content: ''
      }
    }
  },
  methods: {
    handleFeedback() {
      // 提交反馈逻辑
      console.log('反馈表单:', this.form)
      alert('反馈提交成功！')
      this.form = {
        name: '',
        email: '',
        phone: '',
        content: ''
      }
    }
  }
}
</script>

<style scoped>
.home-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}


/* 主视觉区域 */
.hero {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 150px 0 100px;
  color: white;
}

.hero .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 50px;
}

.hero-content {
  flex: 1;
  max-width: 500px;
}

.hero-title {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 20px;
  line-height: 1.2;
}

.hero-subtitle {
  font-size: 18px;
  margin-bottom: 30px;
  opacity: 0.9;
  line-height: 1.6;
}

.hero-buttons {
  display: flex;
  gap: 20px;
}

.btn {
  padding: 15px 30px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  text-decoration: none;
  display: inline-block;
}

.btn-primary {
  background-color: white;
  color: #667eea;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.btn-secondary {
  background-color: transparent;
  color: white;
  border: 2px solid white;
}

.btn-secondary:hover {
  background-color: white;
  color: #667eea;
}

.hero-video {
  flex: 1;
  max-width: 500px;
}

.video-player {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  overflow: hidden;
}

.video-thumbnail {
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.2);
}

.video-thumbnail i {
  font-size: 64px;
  opacity: 0.8;
  transition: opacity 0.3s;
}

.video-thumbnail:hover i {
  opacity: 1;
}

.video-controls {
  padding: 15px;
  background-color: rgba(0, 0, 0, 0.2);
}

.video-progress {
  height: 5px;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 5px;
  margin-bottom: 10px;
}

.video-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}

/* 服务展示区 */
.services {
  padding: 100px 0;
  background-color: #f8f9fa;
}

.section-title {
  text-align: center;
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #333;
}

.section-subtitle {
  text-align: center;
  font-size: 18px;
  color: #666;
  margin-bottom: 50px;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
}

.service-card {
  background-color: white;
  padding: 40px 30px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s, box-shadow 0.3s;
  text-align: center;
}

.service-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.service-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.service-icon i {
  font-size: 32px;
  color: white;
}

.service-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #333;
}

.service-description {
  color: #666;
  line-height: 1.6;
}

/* 关于我们 */
.about {
  padding: 100px 0;
}

.about .container {
  display: flex;
  flex-direction: column;
  gap: 50px;
}

.about-content {
  max-width: 800px;
  margin: 0 auto;
}

.about-text {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
  line-height: 1.8;
}

.about-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 30px;
  margin-top: 50px;
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-size: 48px;
  font-weight: 700;
  color: #667eea;
  margin-bottom: 10px;
}

.stat-label {
  font-size: 16px;
  color: #666;
  font-weight: 500;
}

/* 反馈区域 */
.feedback {
  padding: 100px 0;
  background-color: #f8f9fa;
}

.feedback-form-container {
  max-width: 600px;
  margin: 0 auto;
}

.feedback-form {
  background-color: white;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-weight: 500;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  transition: border-color 0.3s;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
}

.form-group textarea {
  resize: vertical;
  min-height: 150px;
}

.btn-block {
  width: 100%;
}



/* 响应式设计 */
@media (max-width: 768px) {
  .hero .container {
    flex-direction: column;
    text-align: center;
  }
  
  .hero-title {
    font-size: 36px;
  }
  
  .hero-buttons {
    justify-content: center;
  }
  
  .about-stats {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 28px;
  }
  
  .btn {
    padding: 12px 20px;
    font-size: 14px;
  }
  
  .about-stats {
    grid-template-columns: 1fr;
  }
}
</style>